<template>
  <form
    class="search-form"
    :action="searchActionUrl"
    method="get"
    ref="form"
    @submit="submitHandler"
    style="text-align: center"
  >
    <div class="container">
      <div class="row search-page-margins">
        <div class="col-12">
          <h3 v-if="showLinks">{{ $getTranslation("What can we help you find?", $route.params.region)}}</h3>
        </div>
        <div class="col-12">
          <div class="row justify-content-center">
            <div
              class="col-md-4 col-xs-12 col-sm-12 col-lg-3"
              style="margin-bottom: 5px"
            >
              <input
                @focus="searchFocused()"
                @blur="searchBlurred()"
                type="search"
                class="form-control rounded-md"
                name="rmsq"
                v-model="query"
                v-bind:placeholder="$getTranslation('Search', $route.params.region)"
              />
            </div>
            <div
              class="col-md-3 col-xs-12 col-sm-12 col-lg-2"
              style="margin-bottom: 5px"
            >
              <select
                class="form-control select-option"
                name="cat"
                v-model="selectedOption"
              >
                <option value="all">{{
                  $getTranslation("All Categories", $route.params.region)
                }}</option>
                <option
                  v-for="(option, index) in options"
                  :key="index"
                  :value="option.description"
                  v-show="!(['philips-recall','uk-only-link'].includes(option.description))"
                >
                  {{ option.name }}
                </option>
              </select>
            </div>
            <div class="col-md-2 col-xs-12 col-sm-12 col-lg-2" v-if="showLinks">
              <span
                class="input-group-text text-white search-icon-only"
                @click="submitHandler"
              >
                <img alt="search-icon" src="@/assets/images/search-icon.svg"
              /></span>
            </div>
            <div class="col-md-3 col-xs-12 col-sm-12 col-lg-2" v-else>
              <button
                type="button"
                class="input-group-text text-white pl-md-4 pr-md-3 search-btn ctaButton"
                @click="submitHandler"
              >
                <span class="d-md-block">{{
                  $getTranslation("Search", $route.params.region)
                }}</span>
                <img alt="search-icon" src="@/assets/images/search-icon.svg" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="input-group col-3">
      

      
    </div>
      <div class="col-3">
        
      </div> -->
    <div class="input-group-append ml-md-2"></div>

    <!-- <div class="input-group-append d-md-block" v-if="showLinks">
        <span class="input-group-text text-white" @click="submitHandler">
          <img alt="search-icon" src="@/assets/images/search-icon.svg"
        /></span>
      </div> -->
    <!-- </div> -->
  </form>
</template>

<script>
import { mapState } from "vuex";
import UrlHelpers from "../../mixins/url-helpers";

export default {
  props: ["actionUrl", "listCat"],
  mixins: [UrlHelpers],
  computed: {
    ...mapState(["showLinks"]),
    searchActionUrl() {
      // let pathParts = localStorage.getItem("siteUrl").split("/").pop();
      return `/${this.$route.params.region}/search/`;
      // console.log("here", this.actionUrl);
      // if (this.actionUrl) {
      //   return this.actionUrl;
      // } else {
      //   // let pathParts = localStorage.getItem("siteUrl");
      //   let pathParts = location.pathname
      //     .split("/")
      //     .filter((p) => p)
      //     .slice(0, 2);
      //   console.log("pathParts", pathParts);

      //   if (pathParts[1] !== "search") {
      //     pathParts.push("search");
      //   }

      //   return `/${pathParts.join("/")}`;
      // return `${pathParts}/search/`;
      // }
    },
  },
  data() {
    return {
      query: this.getQueryStringParameter("rmsq", ""),
      siteUrl: process.env.VUE_APP_API_ENDPOINT,
      // showLinks: "false",
      selectedOption: this.getQueryStringParameter("cat", "") || "all",
      showCat: this.listCat || false,
      options: [],
    };
  },
  methods: {
    searchFocused() {
      bus.$emit("site-search-focused");
    },
    searchBlurred() {
      bus.$emit("site-search-blurred");
    },
    submitHandler(e) {
      if (!this.query.length) {
        e.preventDefault();
      }
      if (!this.$refs.form[0].value || this.$refs.form[0].value === "all") {
        this.$refs.form[0].remove();
      }

      this.$refs.form.submit();
    },
  },
  mounted() {
    // this.showLinks = sessionStorage.getItem("showLinks");
    // console.log(this.getQueryStringParameter('cat', 'all'));
    console.log("121", this.options);
    // Get top menu bar links
    const address = `${this.siteUrl}/${this.$route.params.region}/wp-json/resmed/v1/navigation/top-navigation`;

    axios.get(address).then((response) => {
      console.log("130", response);
      this.options = response.data[1].children;
    });
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/colors";

.search-form {
  @media (min-width: 992px) {
    margin: 0 6%;
    position: relative;
    z-index: 105;
  }

  .input-group {
    gap: 10px;

    @media (max-width: 768px) {
      flex-direction: column;
    }
  }

  h3 {
    margin-bottom: 0.8125rem;
  }
  .search-btn {
    border-radius: 50rem !important;
  }
  .search-btn {
    @media (max-width: 767px) {
      border-top-right-radius: 5px !important;
      border-bottom-right-radius: 5px !important;
      border-top-left-radius: 5px !important;
      border-bottom-left-radius: 5px !important;
    }
  }

  input[type="search"] {
    height: 38px;
    padding: 0rem 1.3125rem;
    font-size: 0.875rem;
    font-weight: 500;
    letter-spacing: -0.21px;
    // border-top-right-radius: 0.25rem;
    // border-bottom-right-radius: 0.25rem;
    border-radius: 4px !important;

    @media (max-width: 567px) {
      // border-top-right-radius: 0;
      // border-bottom-right-radius: 0;
    }

    &::placeholder {
      color: lighten($cc-resmed-black, 60%);
      font-size: 14px;
      font-family: "Plus Jakarta Sans", sans-serif;
      font-weight: 500;
    }

    &:focus {
      box-shadow: none;
      outline: 0;
      border-color: #ced4da;
    }
  }

  .input-group-text {
    // padding: 0;
    border: 0;
    cursor: pointer;
    background-color: $cc-resmed-action-red;
    font-size: 14px;
    font-family: "Plus Jakarta Sans", sans-serif;
    font-weight: 700;
    justify-content: center;
    height: 38px;

    width: min-content;
    padding: 0 9px;
    margin-left: 20px;

    @media (max-width: 767px) {
      width: 100%;
      margin-left: 0;
    }

    @media screen and (orientation: landscape) and (width: 1024px) {
      margin-left: 32px;
    }

    img {
      height: 32px;
    }
  }
}

.select-option {
  border-radius: 4px !important;
  width: 162px;
  height: 38px;
  font-size: 15px;
  font-family: "Plus Jakarta Sans", sans-serif;
  font-weight: 500;
  padding: 0 14px;
}

.select-option,
.input-group input.form-control,
.search-btn {
  @media (max-width: 768px) {
    width: 100%;
  }
}

:is(.global-search-results .input-group) {
  @media (max-width: 768px) {
    flex-direction: row;
  }
}

:is(.global-search-results .input-group input.form-control) {
  @media (max-width: 768px) {
    width: auto;
  }
}

@media (max-width: 768px) {
  h3 {
    display: none;
  }
}
</style>
